<template>
  <div class="stepper-box">
    <div class="top">
      <div
        class="divider-line"
        :style="{ width: `${(100 / steps.length) * (steps.length - 1) - 10}%` }"
      ></div>
      <div class="steps-wrapper">
        <template v-if="topButtons">
          <div
            v-if="currentStep.index > 0"
            class="stepper-button-top previous"
            @click="backStep()"
          ></div>
        </template>
        <template v-for="(step, index) in steps" ref="pageComponents">
          <div
            :class="['step', isStepActive(index, step)]"
            :key="index"
            :style="{ width: `${100 / steps.length}%` }"
          >
            <div class="outer-circle">
              <span class="inner-circle" @click="stepTitle(index)">
                {{ step.number }}
              </span>
            </div>
            <div class="step-title" @click="stepTitle(index)">
              <img class="mt-4 mb-3" :src="step.icon" />
              <h4>{{ step.title }}</h4>
              <h4>{{ step.subtitle }}</h4>
              <div class="row d-flex justify-content-center mt-3">
                <div
                  :class="[
                    { current_step_line: isStepActive(index) === 'activated' },
                    ''
                  ]"
                ></div>
              </div>
            </div>
          </div>
        </template>
        <div
          v-if="topButtons"
          :class="['stepper-button-top next']"
          @click="nextStep()"
        ></div>
      </div>
    </div>

    <div class="content">
      <div
        v-if="erreurGlobale != ''"
        class="alert alert-danger text-left global-errors erreur-globale mt-5"
      >
        <p>
          {{ erreurGlobale }}
        </p>
      </div>
      <transition
        :enter-active-class="enterAnimation"
        :leave-active-class="leaveAnimation"
        mode="out-in"
      >
        <!--If keep alive-->
        <keep-alive v-if="keepAliveData">
          <component
            :preinscription="preinscription"
            :token="token_out"
            :is="steps[currentStep.index].component"
            :clickedNext="nextButton[currentStep.name]"
            @can-continue="proceed"
            @change-next="changeNextBtnValue"
            :current-step="currentStep"
            ref="pageComponent"
          ></component>
        </keep-alive>
        <!--If not show component and destroy it in each step change-->
        <component
          v-else
          :preinscription="preinscription"
          :token="token_out"
          :is="steps[currentStep.index].component"
          :clickedNext="nextButton[currentStep.name]"
          @can-continue="proceed"
          @go-back="goBack"
          @change-next="changeNextBtnValue"
          :current-step="currentStep"
          ref="pageComponent"
        ></component>
      </transition>
    </div>
    <div
      v-if="erreurGlobale != ''"
      class="alert alert-danger text-left global-errors erreur-globale mt-5"
    >
      <p>
        {{ erreurGlobale }}
      </p>
    </div>
    <div :class="['bottom', currentStep.index > 0 ? '' : 'only-next']">
      <div
        v-if="currentStep.index > 0"
        class="stepper-button previous"
        type="submit"
        @click="backStep()"
      >
        <span>{{ "back" | translate(locale) }}</span>
      </div>
      <b-button
        id="buttonNext"
        :class="['stepper-button next']"
        type="submit"
        @click="nextStep()"
      >
        <b-spinner
          v-if="isLoading === true"
          small
          label="Loading"
          class="mr-1"
        ></b-spinner>
        <span>{{
          finalStep ? "finish" : "next" | translate(locale)
        }}</span></b-button
      >
    </div>
  </div>
</template>

<script>
import translations from "@/Translations.js";
import preinscriptionAppelsServeur from "@/preinscriptionUtils";
import { BSpinner } from "bootstrap-vue";
import _ from "lodash";

export default {
  components: {
    BSpinner
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  props: {
    preinscription: Object,
    token: String,
    locale: {
      type: String,
      default: "fr"
    },
    topButtons: {
      type: Boolean,
      default: false
    },
    steps: {
      type: Array,
      default: function() {
        return [
          {
            icon: "mail",
            number: "1",
            name: "first",
            title: "Sample title 1",
            subtitle: "Subtitle sample"
          },
          {
            icon: "report_problem",
            number: "2",
            name: "second",
            title: "Sample title 2",
            subtitle: "Subtitle sample"
          }
        ];
      }
    },
    keepAlive: {
      type: Boolean,
      default: false
    },
    reset: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentStep: {},
      previousStep: {},
      nextButton: {},
      canContinue: false,
      preinscription_out: {},
      finalStep: false,
      keepAliveData: this.keepAlive,
      erreurGlobale: "",
      isLoading: false,
      token_out: undefined,
      paiementEnLigneEnCours: false
    };
  },
  computed: {
    enterAnimation() {
      if (this.currentStep.index < this.previousStep.index) {
        return "animated quick fadeInLeft";
      } else {
        return "animated quick fadeInRight";
      }
    },
    leaveAnimation() {
      if (this.currentStep.index > this.previousStep.index) {
        return "animated quick fadeOutLeft";
      } else {
        return "animated quick fadeOutRight";
      }
    }
  },
  methods: {
    //   isButtonNextDisabled() {
    //     if (this.currentStep.index === 3) {
    //       return true;
    //     }
    //     return false;
    //   },
    isStepActive(index) {
      if (this.currentStep.index === index) {
        return "activated";
      } else {
        return "deactivated";
      }
    },
    activateStep(index, back = false) {
      if (this.steps[index]) {
        this.previousStep = this.currentStep;
        this.currentStep = {
          name: this.steps[index].name,
          index: index
        };
        if (index + 1 === this.steps.length) {
          this.finalStep = true;
        } else {
          this.finalStep = false;
        }
        if (!back) {
          this.$emit("completed-step", this.previousStep);
        }
      }
      this.$emit("active-step", this.currentStep);
      this.scrollToTop();
    },
    nextStepServerControl(isReconnected) {
      this.erreurGlobale = "";
      var that = this;

      // validation postEtape
      preinscriptionAppelsServeur
        .postEtape(
          this.token_out,
          this.currentStep.index + 3,
          "",
          true,
          this.preinscription_out.data
        )
        .then(result => {
          that.preinscription.data = result;

          if (that.preinscription.data.erreurs.length === 0) {
            if (that.finalStep) {
              if (
                that.preinscription_out.data.generalite.paiementEnLigne ===
                  "L" ||
                that.preinscription_out.data.generalite.paiementEnLigne === "L3"
              ) {
                that.paiementEnLigneEnCours = true;

                preinscriptionAppelsServeur
                  .getPayment(that.token_out)
                  .then(result => {
                    if (result.data) {
                      window.location.href = result.data.redirectURL;
                    } else {
                      that.erreurGlobale =
                        preinscriptionAppelsServeur.formatDateWithTime(
                          new Date()
                        ) +
                        " Une erreur est survenue lors de la redirection vers le formulaire de paiement. Merci de contacter l'assistance";
                    }
                  })
                  .catch(error => {
                    // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
                    var argsArray = [];
                    preinscriptionAppelsServeur.traitementErreursServeur(
                      error,
                      isReconnected,
                      that,
                      that.getPayment,
                      argsArray
                    );

                    if (
                      that.erreurGlobale != null &&
                      that.erreurGlobale != ""
                    ) {
                      // le bouton "JE VALIDE" devient actif si la validation côté serveur n'est pas bien passée
                      that.disableValidation(false);
                    }
                  });
              } else {
                that.$emit("stepper-finished", that.currentStep);
              }
            }
            let currentIndex = that.currentStep.index + 1;
            that.activateStep(currentIndex);
          }
          // le bouton "JE VALIDE" devient actif si la validation côté serveur est bien passée
          if (!that.paiementEnLigneEnCours) {
            that.disableValidation(false);
            that.$forceUpdate();
          }
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.nextStepServerControl,
            argsArray
          );

          if (that.erreurGlobale != null && that.erreurGlobale != "") {
            // le bouton "JE VALIDE" devient actif si la validation cÃ´tÃ© serveur n'est pas bien passÃ©e
            that.disableValidation(false);
          }
        });
    },
    nextStepAction() {
      this.nextButton[this.currentStep.name] = true;
      // quand l'utilisateur fait click sur le bouton "JE VALIDE", le bouton devient grisé et un spinner apparait sur le bouton
      this.disableValidation(true);
      if (this.$refs.pageComponent) {
        this.$refs.pageComponent.canContinue();
      }
      if (this.canContinue) {
        // si la validation côté client passe bien (canContinue == true), on fait aussi une validation côté serveur
        this.nextStepServerControl(false /*isReconnected*/);
        return;
      }
      // le bouton "JE VALIDE" devient actif si la validation côté client n'est pas bien passée
      this.disableValidation(false);
      this.$forceUpdate();
    },
    nextStep() {
      if (!this.$listeners || !this.$listeners["before-next-step"]) {
        this.nextStepAction();
      }
      this.$emit(
        "before-next-step",
        { currentStep: this.currentStep },
        (next = true) => {
          this.canContinue = true;
          if (next) {
            this.nextStepAction();
          }
        }
      );
    },
    backStep() {
      this.$emit("clicking-back");
      // document.getElementById("buttonNext").disabled = false;
      let currentIndex = this.currentStep.index - 1;
      if (currentIndex >= 0) {
        this.activateStep(currentIndex, true);
      }
      this.canContinue = true;
    },
    stepTitle(index) {
      this.erreurGlobale = "";
      this.$refs.pageComponent.erreurGlobale = null;
      // quand on revient aux étapes précédentes, on ne fait pas une validation
      if (index <= this.currentStep.index) {
        this.activateStep(index);
        this.canContinue = true;
        return;
      }

      // console.log(
      //   "page actuelle: " +
      //     (this.currentStep.index + 3) +
      //     "; page suivante wizard:" +
      //     (index + 3)
      // );
      this.nextButton[this.currentStep.name] = true;
      let currentIndex = index;

      // combien d'étapes ont déjà été validées
      let etapesValidees =
        _.countBy(this.preinscription.data.formulaire.validation)["1"] || 0;
      // page courante doit etre validée seulement si non déjà validée
      if (this.currentStep.index + 3 <= etapesValidees) {
        this.canContinue = true;
        this.preinscription_out = JSON.parse(
          JSON.stringify(this.preinscription)
        );
      } else if (this.$refs.pageComponent) {
        this.$refs.pageComponent.canContinue();
      }

      if (this.canContinue) {
        // validation postEtape
        this.postEtapeStepTitle(currentIndex, false /*isReconnected*/);
      }
    },
    postEtapeStepTitle(currentIndex, isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .postEtape(
          this.token_out,
          this.currentStep.index + 3,
          currentIndex + 3,
          false,
          this.preinscription_out.data
        )
        .then(result => {
          that.preinscription.data = result;

          if (that.preinscription.data.erreurs.length === 0) {
            // si on veut passer sur une étape et les étapes précédentes n'ont pas toutes été validées,
            // nous sommes redirigés vers la première étape non-validée
            currentIndex =
              that.preinscription.data.formulaire
                .licencePreinscriptionFormulaireEtape.numeroEtape - 3;
            if (that.finalStep) {
              that.$emit("stepper-finished", that.currentStep);
            }
            that.activateStep(currentIndex);
          }
          that.$forceUpdate();
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          argsArray.push(currentIndex);
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.postEtapeStepTitle,
            argsArray
          );
        });
    },
    proceed(payload) {
      this.canContinue = payload.value;
      this.preinscription_out = payload.preinscription;
    },
    goBack(payload) {
      this.activateStep(payload.numeroEtape - 3);
    },
    changeNextBtnValue(payload) {
      this.nextButton[this.currentStep.name] = payload.nextBtnValue;
      this.$forceUpdate();
    },
    init() {
      // Initiate stepper
      // on passe directement à la première page indiquée par le serveur
      // (la première page qui n'a pas été validée)
      this.activateStep(
        this.preinscription.data.formulaire.licencePreinscriptionFormulaireEtape
          .numeroEtape - 3
      );
      // this.activateStep(0);
      this.steps.forEach(step => {
        this.nextButton[step.name] = false;
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    disableValidation(isDisabled) {
      var buttonNext = document.getElementById("buttonNext");
      buttonNext.disabled = isDisabled;
      this.isLoading = isDisabled;
    }
  },
  watch: {
    reset(val) {
      if (!val) {
        return;
      }
      this.keepAliveData = false;
      this.init();
      this.previousStep = {};
      this.$nextTick(() => {
        this.keepAliveData = this.keepAlive;
        this.$emit("reset", true);
      });
    },
    token: function() {
      if (this.token) {
        this.token_out = JSON.parse(JSON.stringify(this.token));
      }
    }
  },
  created() {
    // la clone token_out est utilisée pour pouvoir mettre a jour le token si la session a expiré (on peut pas modifier directement un prop)
    if (this.token) {
      this.token_out = JSON.parse(JSON.stringify(this.token));
    }
    this.init();
  }
};
</script>

<style src="@/HorizontalStepper.scss" scoped lang="scss"></style>
<style scoped>
/* fallback */
@font-face {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: 400;
  src: local("Material Icons"), local("MaterialIcons-Regular"),
    url(https://fonts.gstatic.com/s/materialicons/v17/2fcrYFNaTjcS6g4U3t-Y5ZjZjT5FdEJ140U2DJYC3mY.woff2)
      format("woff2");
}
.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
}

.outer-circle {
  width: 70px;
  height: 70px;
  border: 1px solid #c4c4c680;
  display: block;
  margin: 0px 10px;
  border-radius: 50%;
  line-height: 50px;
  background: white;
}

.inner-circle {
  width: 60px;
  height: 60px;
  border: 2px solid #0036906b;
  display: block;
  margin: 4px 4px;
  border-radius: 50%;
  line-height: 55px;
  background: white;
  color: #003690;
  font-size: 18px;
  font-weight: bold;
  font-family: Lato;
  cursor: pointer;
}
@media (min-width: 768px) {
  .current_step_line {
    border-bottom: 8px solid #00abe7;
    width: 75%;
    opacity: 0.5;
    /* position: absolute; */
    bottom: 0px;
  }
}

.step-title {
  height: 120px;
}

.content {
  margin-top: 100px !important;
}
</style>
